export enum PRODUCT_DETAILS_TAB {
  SUMMARY = "summary",
  KEYWORDS = "keywords",
  BOOK_DESCRIPTION = "description",
  THEMA = "thema",
  MARKETING = "marketing",
  SALES_DATA = "salesData",
  A_PLUS_CONTENT = "aPlusContent",
  RAW_DATA = "rawData",
}
